// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function weekdayToIndex(weekday) {
  return weekday;
}

function fromString(weekday) {
  switch (weekday) {
    case "Friday" :
    case "friday" :
        return /* Friday */4;
    case "Monday" :
    case "monday" :
        return /* Monday */0;
    case "Saturday" :
    case "saturday" :
        return /* Saturday */5;
    case "Sunday" :
    case "sunday" :
        return /* Sunday */6;
    case "Thursday" :
    case "thursday" :
        return /* Thursday */3;
    case "Tuesday" :
    case "tuesday" :
        return /* Tuesday */1;
    case "Wednesday" :
    case "wednesday" :
        return /* Wednesday */2;
    default:
      return ErrorUtils$Catalyst.raiseError("Weekday.re", "Invalid 'weekday' ", weekday);
  }
}

function indexToWeekday(index) {
  if (index > 6 || index < 0) {
    return ErrorUtils$Catalyst.raiseError("Weekday.re", "Invalid index", String(index));
  } else {
    return index;
  }
}

function toString(weekday) {
  switch (weekday) {
    case /* Monday */0 :
        return "Monday";
    case /* Tuesday */1 :
        return "Tuesday";
    case /* Wednesday */2 :
        return "Wednesday";
    case /* Thursday */3 :
        return "Thursday";
    case /* Friday */4 :
        return "Friday";
    case /* Saturday */5 :
        return "Saturday";
    case /* Sunday */6 :
        return "Sunday";
    
  }
}

function getListOfDaysOfWeek(param) {
  return {
          hd: /* Monday */0,
          tl: {
            hd: /* Tuesday */1,
            tl: {
              hd: /* Wednesday */2,
              tl: {
                hd: /* Thursday */3,
                tl: {
                  hd: /* Friday */4,
                  tl: {
                    hd: /* Saturday */5,
                    tl: {
                      hd: /* Sunday */6,
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        };
}

export {
  weekdayToIndex ,
  fromString ,
  indexToWeekday ,
  toString ,
  getListOfDaysOfWeek ,
  
}
/* No side effect */
